"use client";

import type { QuoteColorSchema } from "@/@sdk/brands/brand-model";
import { SchemaToggle } from "./schema-toggle";

export function ColorSchemaPicker({
  value,
  onChange,
}: {
  value: QuoteColorSchema;
  onChange: (value: QuoteColorSchema) => void;
}) {
  return (
    <SchemaToggle
      value={value}
      onChange={onChange}
      options={[
        { value: "SINGLE_TONE", label: "Single Tone" },
        { value: "DUAL_TONE", label: "Dual Tone" },
      ]}
    />
  );
}
